import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import renderIf from 'render-if';
import {routes} from "../../util/config";
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import {alertLabels, labels, messages} from "../../util/constants";
import TableGridGroups from "../../components/TableGridGroups/tableGridGroups";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSitemap,faPlus} from "@fortawesome/free-solid-svg-icons";
import './groups.css';
import {Button} from "@material-ui/core/umd/material-ui.production.min";
import httpHttpsRequest from '../../util/http-request/request';
import { deleteComponentGroupOptions, getComponentGroupOptions } from '../../util/optionsRequest';

class Groups extends Component {

    constructor(props){
        super(props);
        this.state ={
            data : []
        }
    };

    componentWillMount(){
        this.getDataGroups();
    };

    disableGroup=(id_group)=>{
        let param = {id_group};

        let http = new httpHttpsRequest(deleteComponentGroupOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.groupDisabled(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    groupDisabled = (response) =>{
        try{
            if(response != null && response.success == true){
                this.getDataGroups();
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.groupDisabled, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }

    };

    getDataGroups=()=>{
        let http = new httpHttpsRequest(getComponentGroupOptions);

        http.makeRequest().then((data)=>{this.groupsSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    groupsSuccess = (response) =>{
        if(response.data && response.data.length > 0){
            this.setState({data:response.data});
        }else{
            this.setState({data:response.data});//TODO DIONI- REFACTORAR
            setAlertOnRedux(true,alertLabels.iconInfo,messages.emptyData, alertLabels.alertInfo);
        }

    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, JSON.parse(response.body).message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    redirectToNewGroup = () =>{
        this.props.history.push({pathname: routes.newGroup})
    };

    redirectToEditGroup = (data) =>{
        let group = {...data};
        this.props.history.push({
            pathname: routes.newGroup,
            state: { group: group, isEdit:true }
        })
    };

    redirectToEditItemsGroup = (data) =>{
        this.props.history.push({
            pathname: routes.item,
            state: { id_group: data.id_group, component_group_name:data.group_name_pt} //TODO - VERIFICAR IDIOMA
        })
    };

    render() {
        return (
            <div className="container groups">
                <h1 className='title'>{'\u00A0'} <FontAwesomeIcon icon={faSitemap} />{'\u00A0'} {labels.cstGroups}</h1>
                <div className={'newGroup'}>
                    <Button variant="contained"  color="primary" onClick={()=>{this.redirectToNewGroup()}}>
                        <FontAwesomeIcon icon={faPlus} /> &nbsp;&nbsp;{labels.newGroup}
                    </Button>
                </div>
                {
                    renderIf(this.state.data.length > 0)
                    (
                        <TableGridGroups options={[]} data={this.state.data} disableGroup={this.disableGroup}
                                         redirectToEditItemsGroup={this.redirectToEditItemsGroup} redirectToEditGroup={this.redirectToEditGroup}/>
                    )
                }

            </div>
        )
    }
}

export default withRouter(Groups);


// WEBPACK FOOTER //
// ./src/containers/cst_group/groups.js